<template>
  <form
    class="formCont"
    :action="dataBO.form.formUrl"
    method="post"
    @submit="validadeForms"
  >
    <input type="hidden" name="id" value="hyundai_vue" />
    <input type="hidden" name="cfg" id="cfgXMLConfig" value="hyundai_vue_cfg" />

    <input
      type="hidden"
      name="form_type"
      id="cfgFormType"
      value="CFG - Pedido Proposta Comercial"
    />
    <input
      type="hidden"
      name="from_page"
      id="cfgFormType"
      :value="$route.path"
    />
    <input type="hidden" name="lead_type" :value="dataBO.form.lead_type" />
    <input
      type="hidden"
      name="form_type_code"
      :value="dataBO.form.form_type_code"
    />

    <input
      type="hidden"
      name="redirok"
      id="redirok"
      value="https://www.hyundai.pt/mensagem-enviada"
    />
    <input
      type="hidden"
      name="redirnok"
      id="redirnok"
      value="https://www.hyundai.pt/problema-envio"
    />

    <input type="hidden" name="model" id="model" :value="resumeData.model" />
    <input
      type="hidden"
      name="id_model"
      id="id_model"
      :value="resumeData.modelid"
    />

    <input type="hidden" name="oid_dealer" id="oid_dealer" :value="dealer" />
    <input
      type="hidden"
      name="stand"
      id="stand"
      :value="getDealerKeyValueById(dealer, 'designation')"
    />
    <input
      type="hidden"
      name="dealer_email"
      id="dealer_email"
      :value="getDealerKeyValueById(dealer, 'email')"
    />

    <input
      type="hidden"
      name="typeService"
      id="typeService"
      :value="dataBO.form.typeService"
    />
    <input type="hidden" name="modelSelected" id="modelSelected" value="" />
    <input type="hidden" name="addAllOption" id="addAllOption" value="false" />

    <input
      type="hidden"
      name="leadSource"
      :value="isGov ? dataBO.form.leadSourceGov : dataBO.form.leadSource"
    />
    <input
      type="hidden"
      name="idSubscriptionCenterOrigin"
      :value="dataBO.form.idSubscriptionCenterOrigin"
    />
    <input
      type="hidden"
      name="contactType"
      id="contactType"
      :value="dataBO.form.contactType"
    />

    <input
      type="hidden"
      id="configurationID"
      name="configurationID"
      :value="resumeData.uniqueID"
    />
    <!-- <input type="hidden" id="configurationPDFE" name="configurationPDFE" value=""> -->

    <input type="hidden" name="utm_source" value="" />
    <input type="hidden" name="utm_medium" value="" />
    <input type="hidden" name="utm_campaign" value="" />
    <input type="hidden" name="utm_term" value="" />
    <input type="hidden" name="utm_content" value="" />

    <!-- *** Info -->
    <h2 class="formCont-title">Introduza os seus dados</h2>
    <Input
      field="name"
      labelText="Nome"
      placeholder="Nome"
      :curValue.sync="name"
      :errorText="errorMsg.name"
      :isValid="formFieldsState.name"
    />

    <Input
      field="email"
      labelText="Email"
      placeholder="Email"
      :curValue.sync="email"
      :errorText="errorMsg.email"
      :isValid="formFieldsState.email"
    />

    <Input
      field="telefone"
      labelText="Telemóvel"
      placeholder="Telemóvel"
      :maxLenght="9"
      :curValue.sync="phone"
      :errorText="errorMsg.phone"
      :isValid="formFieldsState.phone"
    />

    <!-- *** Dealers -->
    <h2 class="formCont-title">Escolha o seu concessionário Hyundai</h2>
    <DropDown
      field="id_distrito"
      :fieldOptions="getDistrict"
      labelText="Selecione um distrito"
      :currOpt.sync="id_distrito"
      :errorText="errorMsg.district"
      :isValid="formFieldsState.district"
    />

    <DropDown
      field="dealer"
      :fieldOptions="getDealersLst(id_distrito)"
      labelText="Selecione um concessionário"
      :currOpt.sync="dealer"
      :isDisabled="id_distrito == '' ? true : false"
      :errorText="errorMsg.dealer"
      :isValid="formFieldsState.dealer"
    />

    <TextArea
      field="msg"
      labelText="Deixe a sua mensagem ao concessionario"
      :curValue.sync="msg"
    />

    <!-- *** Clock -->
    <!-- <h2 class="formCont-title">Selecione o melhor horário de contacto</h2>
        <DropDown field="hour"
        :simpleArr="true" :fieldOptions="generateStrTimesArr()" labelText="Selecionar horário" :currOpt.sync="hour" /> -->

    <!-- *** CheckBox -->
    <CheckBox
      fieldClass="squareCheckbox acceptPP"
      field="accept"
      value="S"
      :isLink="true"
      :errorText="errorMsg.accept"
      :isValid="formFieldsState.accept"
      :fieldLabel="getAcceptText"
      @checked-item="handlePolicy($event)"
    />

    <CheckBox field="disclaimer" value="S" :fieldLabel="disclaimerText" />
    <button class="btn-primary" :disabled="pending">{{ btnLabel }}</button>
  </form>
</template>
<script>
import Input from "@/components/FormFields/Input/Input.vue";
import CheckBox from "@/components/FormFields/CheckBox/CheckBox.vue";
import DropDown from "@/components/FormFields/DropDown/DropDown.vue";
import TextArea from "@/components/FormFields/Input/TextArea.vue";
import { formValidation } from "@/mixins/formValidation";

export default {
  name: "FormProposal",
  components: { Input, CheckBox, DropDown, TextArea },
  mixins: [formValidation],
  data() {
    return {
      formFieldsState: {
        name: true,
        email: true,
        phone: true,
        district: true,
        dealer: true,
        msg: true,
        accept: true,
      },
    };
  },
  methods: {
    generateStrTimesArr() {
      let arr = [{ objectId: "", designation: "Selecionar horário" }];
      for (let i = 9; i < 19; i++) {
        let obj = {
          objectId: i,
          designation: i + ":00",
        };

        if (i != 13) arr.push(obj);
      }
      return arr;
    },
  },
};
</script>
<style lang="scss">
@import "./FormStyle.scss";
</style>
